import { Config } from 'tailwindcss'

const config = {
  mode: 'jit',
  content: {
    relative: true,
    files: [
      '../../apps/*/src/**/*.{js,jsx,ts,tsx}',
      '../../packages/ui/components/**/*.{js,jsx,ts,tsx}',
      '../../packages/ui/constants/**/*.{js,jsx,ts,tsx}',
      '../../packages/ui/icons/**/*.{js,jsx,ts,tsx}',
      '../../packages/ui/types/**/*.{js,jsx,ts,tsx}',
      '../../packages/toolkit/src/**/*.{js,jsx,ts,tsx}'
    ]
  },
  theme: {
    extend: {
      backgroundImage: {
        'custom-gradient':
          'linear-gradient(180deg, rgba(226, 99, 28, 0.8) 0%, rgba(226, 55, 1, 0.8) 11%, rgba(198, 0, 95, 0.8) 39.5%, #A101AF 63%, #7201E2 78%, rgba(14, 30, 167, 0.8) 100%)'
      }
    },
    colors: {
      primary: {
        light: {
          DEFAULT: 'var(--color-primary-light)',
          hover: 'var(--color-primary-light-hover)',
          active: 'var(--color-primary-light-active)'
        },
        DEFAULT: 'var(--color-primary)',
        hover: 'var(--color-primary-hover)',
        active: 'var(--color-primary-active)',
        dark: {
          DEFAULT: 'var(--color-primary-dark)',
          hover: 'var(--color-primary-dark-hover)',
          active: 'var(--color-primary-dark-active)'
        },
        darker: 'var(--color-primary-darker)'
      },
      secondary: {
        light: {
          DEFAULT: 'var(--color-secondary-light)',
          hover: 'var(--color-secondary-light-hover)',
          active: 'var(--color-secondary-light-active)'
        },
        DEFAULT: 'var(--color-secondary)',
        hover: 'var(--color-secondary-hover)',
        active: 'var(--color-secondary-active)',
        dark: {
          DEFAULT: 'var(--color-secondary-dark)',
          hover: 'var(--color-secondary-dark-hover)',
          active: 'var(--color-secondary-dark-active)'
        },
        darker: 'var(--color-secondary-darker)'
      },
      orange: {
        light: {
          DEFAULT: 'rgb(253 241 230)',
          hover: 'rgb(252 234 217)',
          active: 'rgb(248 211 177)'
        },
        DEFAULT: 'rgb(234 114 4)',
        hover: 'rgb(211 103 4)',
        active: 'rgb(187 91 3)',
        dark: {
          DEFAULT: 'rgb(176 86 3)',
          hover: 'rgb(140 68 2)',
          active: 'rgb(105 51 2)'
        },
        darker: 'rgb(82 40 1)'
      },

      black: {
        light: {
          DEFAULT: 'rgb(230 230 230)',
          hover: 'rgb(217 217 217)',
          active: 'rgb(176 176 176)'
        },
        DEFAULT: 'rgb(0 0 0)',
        hover: 'rgb(0 0 0)',
        active: 'rgb(0 0 0)',
        dark: {
          DEFAULT: 'rgb(0 0 0)',
          hover: 'rgb(0 0 0)',
          active: 'rgb(0 0 0)'
        },
        darker: 'rgb(0 0 0)'
      },
      red: {
        light: {
          DEFAULT: 'rgb(249 230 236)',
          hover: 'rgb(246 218 226)',
          active: 'rgb(236 179 195)'
        },
        DEFAULT: 'rgb(193 9 62)',
        hover: 'rgb(174 8 56)',
        active: 'rgb(154 7 50)',
        dark: {
          DEFAULT: 'rgb(145 7 47)',
          hover: 'rgb(116 5 37)',
          active: 'rgb(87 4 28)'
        },
        darker: 'rgb(68 3 22)',
        secondary: {
          light: {
            DEFAULT: 'rgb(253 235 235)',
            hover: 'rgb(251 217 217)',
            active: 'rgb(246 176 176)'
          },
          DEFAULT: 'rgb(226 0 0)',
          hover: 'rgb(203 0 0)',
          active: 'rgb(181 0 0)',
          dark: {
            DEFAULT: 'rgb(170 0 0)',
            hover: 'rgb(136 0 0)',
            active: 'rgb(102 0 0)'
          },
          darker: 'rgb(79 0 0)'
        }
      },
      green: {
        light: {
          DEFAULT: 'rgb(236 249 230)',
          hover: 'rgb(226 246 217)',
          active: 'rgb(195 235 177)'
        },
        DEFAULT: 'rgb(62 192 3)',
        hover: 'rgb(56 173 3)',
        active: 'rgb(50 154 2)',
        dark: {
          DEFAULT: 'rgb(47 144 2)',
          hover: 'rgb(37 115 2)',
          active: 'rgb(28 86 1)'
        },
        darker: 'rgb(22 67 1)'
      },
      yellow: {
        DEFAULT: 'rgb(220, 176, 17)',
        light: 'rgb(255, 250, 232)'
      },
      grey: {
        light: {
          DEFAULT: 'rgb(236 236 236)',
          hover: 'rgb(226 226 226)',
          active: 'rgb(166 166 166)'
        },
        DEFAULT: 'rgb(61 61 61)',
        stroke: 'rgb(195 195 195)',
        lighter: 'rgb(99 99 99)',
        hover: 'rgb(55 55 55)',
        active: 'rgb(49 49 49)',
        dark: {
          DEFAULT: 'rgb(46 46 46)',
          hover: 'rgb(37 37 37)',
          active: 'rgb(27 27 27)'
        },
        darker: 'rgb(21 21 21)'
      },
      fushia: {
        light: {
          DEFAULT: 'rgb(252 232 243)',
          hover: 'rgb(251 221 237)',
          active: 'rgb(247 184 218)'
        },
        DEFAULT: 'rgba(229, 25, 135)',
        hover: 'rgb(206 23 122)',
        active: 'rgb(183 20 108)',
        dark: {
          DEFAULT: 'rgb(172 19 101)',
          hover: 'rgb(137 15 81)',
          active: 'rgb(103 11 61)'
        },
        darker: 'rgb(80 9 47)'
      },
      white: {
        light: {
          DEFAULT: 'rgb(255 255 255)',
          hover: 'rgb(255 255 255)',
          active: 'rgb(255 255 255)'
        },
        DEFAULT: 'rgb(255 255 255)',
        hover: 'rgb(249 249 249)',
        active: 'rgb(246 246 246)',
        dark: {
          DEFAULT: 'rgb(242 242 242)',
          hover: 'rgb(153 153 153)',
          active: 'rgb(115 115 115)'
        },
        darker: 'rgb(89 89 89)'
      },
      secondaryRed: {
        light: {
          DEFAULT: 'rgb(253 235 235)',
          hover: 'rgb(251 217 217)',
          active: 'rgb(246 176 176)'
        },
        DEFAULT: 'rgb(226 0 0)',
        hover: 'rgb(203 0 0)',
        active: 'rgb(181 0 0)',
        dark: {
          DEFAULT: 'rgb(170 0 0)',
          hover: 'rgb(136 0 0)',
          active: 'rgb(102 0 0)'
        },
        darker: 'rgb(79 0 0)'
      },
      blue: {
        light: {
          DEFAULT: 'rgb(236 243 255)',
          hover: 'rgb(236 243 255)',
          active: 'rgb(181 210 255)'
        },
        DEFAULT: 'rgb(15 111 255)',
        hover: 'rgb(14 100 230)',
        active: 'rgb(12 89 204)',
        dark: {
          DEFAULT: 'rgb(11 83 191)',
          hover: 'rgb(9 67 153)',
          active: 'rgb(7 50 115)'
        },
        darker: 'rgb(5 39 89)'
      },
      navyBlue: {
        light: {
          DEFAULT: 'rgb(230 230 240)',
          hover: 'rgb(218 217 232)',
          active: 'rgb(178 177 208)'
        },
        DEFAULT: 'rgb(5 4 103)',
        hover: 'rgb(5 4 93)',
        active: 'rgb(4 3 82)',
        dark: {
          DEFAULT: 'rgb(4 3 77)',
          hover: 'rgb(3 2 62)',
          active: 'rgb(2 2 46)'
        },
        darker: 'rgb(2 1 36)'
      },
      vividBlue: {
        DEFAULT: 'rgb(31 1 226)',
        active: 'rgb(25, 1, 181)',
        light: {
          DEFAULT: 'rgb(237 235 253)',
          active: 'rgb(186 176 246)'
        }
      },
      orchid: {
        light: {
          DEFAULT: 'rgb(247 235 250)',
          hover: 'rgb(244 224 248)',
          active: 'rgb(231 191 240)'
        },
        DEFAULT: 'rgb(179 50 205)',
        hover: 'rgb(161 45 185)',
        active: 'rgb(143 40 164)',
        dark: {
          DEFAULT: 'rgb(134 38 154)',
          hover: 'rgb(107 30 123)',
          active: 'rgb(81 22 92)'
        },
        darker: 'rgb(63 18 72)'
      },
      purple: {
        light: {
          DEFAULT: 'rgb(237 235 253)',
          hover: 'rgb(221 217 251)',
          active: 'rgb(186 176 246)'
        },
        DEFAULT: 'rgba(100 49 242)',
        hover: 'rgb(28 1 203)',
        active: 'rgb(25 1 181)',
        dark: {
          DEFAULT: 'rgb(23 1 170)',
          hover: 'rgb(19 1 136)',
          active: 'rgb(14 0 102)'
        },
        darker: 'rgb(11 0 79)'
      },
      brown: {
        light: {
          DEFAULT: 'rgb(244 236 232)',
          hover: 'rgb(239 226 221)',
          active: 'rgb(221 195 185)'
        },
        DEFAULT: 'rgb(145 60 29)',
        hover: 'rgb(131 54 26)',
        active: 'rgb(116 48 23)',
        dark: {
          DEFAULT: 'rgb(109 45 22)',
          hover: 'rgb(87 36 17)',
          active: 'rgb(65 27 13)'
        },
        darker: 'rgb(51 21 10)'
      },
      background: {
        light: {
          DEFAULT: 'rgb(253 255 255)',
          hover: 'rgb(252 255 255)',
          active: 'rgb(250 254 255)'
        },
        DEFAULT: 'rgb(238 252 254)',
        hover: 'rgb(214 227 229)',
        active: 'rgb(190 202 203)',
        dark: {
          DEFAULT: 'rgb(179 189 191)',
          hover: 'rgb(143 151 152)',
          active: 'rgb(107 113 114)'
        },
        darker: 'rgb(83 88 89)'
      },
      transparent: 'transparent'
    },
    borderRadius: {
      xs: '4px',
      sm: '8px',
      DEFAULT: '12px',
      lg: '16px',
      xl: '20px',
      '2xl': '24px',
      '3xl': '32px',
      full: '9999px',
      none: '0px'
    },
    boxShadow: {
      DEFAULT: '0px 0px 26px #93939320',
      bottom: '0px 4px 8px #93939320'
    },
    keyframes: {
      // Radix UI Dialog keyframe
      overlayShow: {
        from: { opacity: '0' },
        to: { opacity: '1' }
      },
      // Radix UI Dialog keyframe
      contentShow: {
        from: {
          opacity: '0',
          transform: 'translate(-50%, -48%) scale(0.96)'
        },
        to: { opacity: '1', transform: 'translate(-50%, -50%) scale(1)' }
      },
      spin: {
        from: { transform: 'rotate(0deg)' },
        to: { transform: 'rotate(360deg)' }
      },
      'accordion-down': {
        from: { height: '0' },
        to: { height: 'var(--radix-accordion-content-height)' }
      },
      'accordion-up': {
        from: { height: 'var(--radix-accordion-content-height)' },
        to: { height: '0' }
      },
      pulse: {
        '0%, 100%': { opacity: '1' },
        '50%': { opacity: '0.5' }
      }
    },
    screens: {
      mobile: { max: '530px' },
      tab: { min: '531px', max: '767px' },
      smallLaptop: { min: '768px', max: '1024px' },
      laptop: { min: '1025px', max: '1300px' }
    },
    // Radix UI Dialog animation
    animation: {
      overlayShow: 'overlayShow 150ms cubic-bezier(0.16, 1, 0.3, 1)',
      contentShow: 'contentShow 150ms cubic-bezier(0.16, 1, 0.3, 1)',
      spin: 'spin 1s linear infinite',
      'accordion-down': 'accordion-down 0.2s ease-out',
      'accordion-up': 'accordion-up 0.2s ease-out',
      pulse: 'pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite'
    }
  },
  variants: {
    extend: {
      placeholderOpacity: ['focus']
    }
  },
  plugins: [
    function ({ addUtilities }: { addUtilities: (utilities: Record<string, any>) => void }) {
      addUtilities({
        '.mobile-scroll': {
          '@media (max-width: 530px)': {
            overflow: 'auto',
            'scrollbar-width': 'none',
            'max-height': '87vh',
            'padding-bottom': '2.5rem',
            '&::-webkit-scrollbar': {
              display: 'none'
            }
          }
        }
      })
    }
  ]
} as const satisfies Config

export default config
